import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import { userActions } from "../../_actions";
import { AdminMessage, Chart, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/indexPdp.css";
import EDUCalenderDark from "../../assets/images/EDUCalender-dark.png";
import EDUOptionDark from "../../assets/images/EDUOption-dark.png";
import EDUOption from "../../assets/images/EDUOption.png";
import ExamDark from "../../assets/images/Exam-dark.png";
import pdpDark from "../../assets/images/pdp-dark.png";
import pdp from "../../assets/images/pdp.png";
import reportCardDark from "../../assets/images/reportCard-dark.png";
import { formatDate } from "../../_helpers/formatDate";

class IndexPdp_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wards: [],
      ward: "",
      general_indicators_info: null,
      chart1: null,
      chart2: null,
      indicator: "",
      isRequestEduDone: false,
      BtnList: [
        {
          img: pdp,
          text: "نیازسنجی آموزشی",
          to: "/pdp/requestEdu",
          hover: "نیازسنجی آموزشی",
          onClick: () => "",
        },
        {
          img: EDUOptionDark,
          text: "مشاهده وضعیت",
          to: null,
          // to: "/pdp/requestEduStatus",
          hover: "ابتدا دوره های خود را درخواست کنید.",
          onClick: () => "",
        },
        {
          img: EDUCalenderDark,
          text: "تقویم فردی آموزش",
          to: null,
          hover: "بزودی",
          onClick: () => "",
        },
        {
          img: ExamDark,
          text: "آزمون",
          to: null,
          hover: "بزودی",
          onClick: () => "",
        },
        {
          img: reportCardDark,
          text: "کارنامه آموزشی",
          to: null,
          hover: "بزودی",
          onClick: () => "",
        },
      ],
      submitDate: "",
      statistics: [],
      validUser: false,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount() {
    this.getUserWards();
    this.getCourses();
  }

  componentDidUpdate(Props, State) {
    if (State.isRequestEduDone !== this.state.isRequestEduDone) {
      this.setState({
        BtnList: this.state.BtnList.map((btn) => {
          if (btn.to === "/pdp/requestEdu") {
            return {
              img: pdpDark,
              text: "نیازسنجی آموزشی",
              to: null,
              // to: "/pdp/requestEdu",
              hover: "شما قبلا درخواست خود را نهایی کرده اید.",
              onClick: () =>
                this.warnAfterFinalSubmitReqEdu(
                  formatDate(this.state.submitDate)
                ),
            };
          }
          if (btn.text === "مشاهده وضعیت") {
            return {
              img: EDUOption,
              text: "مشاهده وضعیت",
              to: "/pdp/requestEduStatus",
              hover: "مشاهده وضعیت",
              onClick: () => "",
            };
          }
          return btn;
        }),
      });
    }
  }

  goBack = () => {
    this.props.history.goBack();
  };

  getStatistics = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/course/statistics`))
      .then((res) => {
        this.setState({ statistics: res.data });
        // const randomCurrUserReq = res.data.find((req) => req.user_id);
        // this.setState({
        //   submitDate: res.data[0] ? res.data[0].submitted_at : "",
        //   isRequestEduDone:
        //     randomCurrUserReq === undefined
        //       ? false
        //       : randomCurrUserReq.status !== "draft",
        // });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getUserWards = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/user_wards`))
      .then((res) => {
        const superiorIds = res.data.map(({ user_id }) => +user_id);
        const myId = this.globalStorage.me.id;
        this.setState({ validUser: superiorIds.includes(myId) });
        this.getStatistics();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getCourses = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/courses`))
      .then((res) => {
        const randomCurrUserReq = res.data.find((req) => req.user_id);
        this.setState({
          submitDate: res.data[0] ? res.data[0].submitted_at : "",
          isRequestEduDone:
            randomCurrUserReq === undefined
              ? false
              : randomCurrUserReq.status !== "draft",
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  warnAfterFinalSubmitReqEdu = (x = "0000/00/00") => {
    this.props.dispatch(
      userActions.warningWithSubmit(
        "متوجه شدم",
        `شما نیازسنجی آموزشی خود را در تاریخ ${x} نهایی کرده اید. جهت مشاهده وضعیت درخواست های خود به بخش بررسی وضعیت دوره های آموزشی مراجعه نمایید.`,
        "انصراف"
      )
    );
  };

  render() {
    const { indicator, ward, wards, BtnList, statistics } = this.state;
    const { indicators } = this.props.globalStorage;

    return (
      <div className="content bg-drr pt-3 pb-5 px-3 indexPdp">
        <Routes page="pdp" />
        <div className="container-fluid adminMessage">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <br />
        <div className="container-fluid">
          <div
            className="row my-1 d-flex flex-column justify-content-center align-items-center"
            style={{ gap: "50px" }}
          >
            <div className="col-lg-5 statistics mx-auto">
              <CardSection statistics={statistics} />
            </div>

            <div className="col-6 indexSec">
              <div className="border-0 h-100 ">
                <RoundedBtnWrapper>
                  {BtnList.map((btn) => (
                    <RoundedBtn
                      key={btn.text}
                      btn={btn}
                      onClick={btn.onClick}
                    />
                  ))}
                </RoundedBtnWrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class CardSection extends Component {
  render() {
    const {
      total,
      total_accepted,
      total_general,
      total_optional,
      total_rejects,
      total_required,
    } = this.props.statistics;
    return (
      <>
        <div className="card-deck">
          <Card text="کل نیازسنجی های درخواست شده" value={total} bg="#0040ff" />
          <Card
            text="نیازسنجی های تایید نشده"
            value={total_rejects}
            bg="#18187a"
          />
          <Card
            text="نیازسنجی هـای تایید شده"
            value={total_accepted}
            bg="#1f3d80"
          />
        </div>
        <br />
        <div className="card-deck">
          <Card
            text="نیازسنجی هـای الزامـی"
            value={total_required}
            bg="#00b088"
          />
          <Card text="نیازسنجی هـای عمومی" value={total_general} bg="#2bb5b2" />
          <Card
            text="نیازسنجی های اختیـاری"
            value={total_optional}
            bg="#52b9c7"
          />
        </div>
      </>
    );
  }
}

class Card extends Component {
  render() {
    const { text, value, bg } = this.props;
    return (
      <div
        className="card text-center"
        style={{ borderRadius: "20px", background: bg }}
      >
        <div className="card-body">
          <p className="card-title">
            <small
              className="iran-sans_Bold"
              style={{ color: "#ffffff", fontSize: "12px" }}
            >
              {text}
            </small>
          </p>
          <h5
            className="card-text iran-sans_Bold my-1"
            style={{ color: "#ffffff", fontSize: "20px" }}
          >
            {value}
          </h5>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0 shadow-smm m-0"
        style={{ borderRadius: "20px" }}
      >
        <div
          className="align-items-center card-body d-flex justify-content-center p-0"
          style={{ minHeight: "235px" }}
        >
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck" style={{ gap: "45px" }}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  renderContent = () => {
    const { img, text } = this.props.btn;
    return (
      <>
        <img
          src={img}
          alt=""
          width="75"
          height="75"
          className="rounded-circle"
        />
        <span
          className="iran-sans_Bold text-center text-dark my-2"
          style={{
            width: "100px",
            fontSize: "12px",
            paddingTop: "10px",
          }}
        >
          {text}
        </span>
      </>
    );
  };

  render() {
    const { renderContent } = this;
    const { onClick, btn } = this.props;
    const { to, hover } = btn;

    return (
      <div className="card text-center border-0 m-0">
        <div className="card-body border-0 d-flex justify-content-center p-0">
          {to ? (
            <NavLink
              className="d-flex flex-column align-items-center indexs btn p-0"
              to={to}
              data-tip={hover}
            >
              {renderContent()}
            </NavLink>
          ) : (
            <a
              className="d-flex flex-column align-items-center indexs btn p-0"
              data-tip={hover}
              onClick={onClick}
            >
              {renderContent()}
            </a>
          )}
          {/* <ReactTooltip type="dark" /> */}
        </div>
      </div>
    );
  }
}

const IndexPdp = connect((state) => ({
  globalStorage: state.globalStorage,
}))(IndexPdp_);
export { IndexPdp };
